export default __webpack_public_path__ + "static/media/white-house.d9e4fd82.jpg";